module.exports = __webpack_public_path__ + "img/Rooster.382c442c.webp";